import { render, staticRenderFns } from "./employeeOutinsuranceSchool.vue?vue&type=template&id=bb774086&scoped=true&"
import script from "./employeeOutinsuranceSchool.vue?vue&type=script&lang=js&"
export * from "./employeeOutinsuranceSchool.vue?vue&type=script&lang=js&"
import style0 from "./employeeOutinsuranceSchool.vue?vue&type=style&index=0&id=bb774086&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb774086",
  null
  
)

export default component.exports